import { formatComplianceDate } from '@/features/compliance/formatDates'
import {
  catalogDataSchema,
  emptyCatalogData,
  DEFAULT_CATALOG,
} from '@/features/compliance/catalog/catalogModel'
import source from './anamnesebogenV2.json'

// Immutable, visually transcribed source. Changes require a new catalog version.
export const PDF_SOURCE = source
export const SOURCE_ATTESTATION = source.notices.map((n) => `${n.title}\n${n.text}`).join('\n\n')
export const sourceDataSchema = catalogDataSchema(DEFAULT_CATALOG)
export function emptySourceData(name = ''): Record<string, string> {
  return emptyCatalogData(DEFAULT_CATALOG, name)
}
export function sourceAnswer(field: { kind: string }, value: string): string {
  if (!value) return 'Keine Angabe'
  if (field.kind === 'yesNo' || field.kind === 'check') return value === 'YES' ? 'ja' : 'nein'
  if (field.kind === 'date') return formatComplianceDate(value)
  return value
}
